import * as Rx from 'rxjs';
import * as _ from 'lodash';
import {IProgressProvider} from "../PA.Core.IF.Basic";
import {Subscription} from "rxjs";

const bDebug = false

export class ProgressProviderMultiplexor
    implements IProgressProvider
{
    process_name: string;
    process_running: boolean;
    process_pcnt_complete: number;
    process_progress_numerator: number;
    process_progress_denominator: number;
    process_completed: boolean;
    process_failed: boolean;
    process_exception: any;
    progress_message_id: string;
    progress_message_text: string;
    ProgressChanged: Rx.BehaviorSubject<IProgressProvider>;
    OnComplete: Rx.BehaviorSubject<IProgressProvider>;
    process_parent: any;
    arrSources: {
        progressProvider: IProgressProvider,
        subOnChange: Subscription,
        subOnComplete: Subscription
    }[]

    constructor(name?: string, parent?: any)
    {
        this.setName(name);
        this.process_completed = true;
        this.process_running = false;
        this.process_pcnt_complete = 0;
        this.process_progress_numerator = 0;
        this.process_progress_denominator = 100;
        this.process_failed = false;
        this.process_exception = {};
        this.progress_message_id = "";
        this.progress_message_text = "";
        this.ProgressChanged = new Rx.BehaviorSubject<IProgressProvider>(null);
        this.OnComplete = new Rx.BehaviorSubject<IProgressProvider>(null);
        this.process_parent = parent;
        this.arrSources = []
    }

    setName(name: string): void {
        this.process_name = name || this.process_name ||'Unnamed';

    }

    start(name?: string): void {
        this.setName(name);

        this.process_running = true;
        this.process_completed = false;
        this.process_pcnt_complete = 0;
        this.process_failed = false;
        this.process_exception = {};
        this.progress_message_id = "";
        this.progress_message_text = "";
        this._notify();
    }


    setProgressMessage(message_id: string, message_text: string): void {
        this.progress_message_id = message_id;
        this.progress_message_text = message_text;
        this._notify();

    }

    setPercentComplete(pcnt_complete: number) {
        this.process_pcnt_complete = pcnt_complete;
        if (this.process_progress_denominator > 0) {
            this.process_progress_numerator = pcnt_complete * this.process_progress_denominator
        }
        this._notify();

    }


    setProgressNumerator(numerator: number): void {

        this.process_progress_numerator = numerator;
        if (this.process_progress_denominator > 0) {
            this.process_pcnt_complete = numerator / this.process_progress_denominator
        }
        this._notify();

    }

    setProgressDenominator(denominator: number): void {

        this.process_progress_denominator = denominator;
        if (this.process_progress_denominator > 0) {
            this.process_pcnt_complete = this.process_progress_numerator / this.process_progress_denominator
        }
        this._notify();

    }

    finish(): void {
        this.process_pcnt_complete = 100;
        this.process_running = false;
        this.process_completed = true;
        this.process_failed = false;
        this._notify();
        this._notifyComplete();

    }

    exception(anError: any): void {
        this.process_exception = anError;
        this.process_failed = true;
        this.process_running = false;
        this.process_completed = true;
        this._notify();
        this._notifyComplete();

    }

    _notify(){
        var self = this;
        setTimeout(function(){
            self.ProgressChanged.next(self);
        },0);

    }

    _notifyComplete(){
        var self = this;
        setTimeout(function(){
            self.OnComplete.next(self);
        },0);

    }

    addSource(aProgressProvider: IProgressProvider): void {
        const self = this
        if(_.isEmpty(aProgressProvider))
            return

        let bFound = false
        _.forEach(this.arrSources, (aSrc) => {
            if(aSrc.progressProvider == aProgressProvider){
                bFound = true
                return false
            }
        })

        if(bFound)
            return

        let aNewSource = {
            progressProvider: aProgressProvider,
            subOnChange: aProgressProvider.ProgressChanged.subscribe(self.onSourceChange.bind(self)),
            subOnComplete: aProgressProvider.OnComplete.subscribe(self.onSourceComplete.bind(self)),
        }

        self.arrSources.push(aNewSource)
        self._updateState(false)
    }

    removeSource(aProgressProvider: IProgressProvider): void {
        const self = this
        if (_.isEmpty(aProgressProvider))
            return

        let removed = _.remove(self.arrSources, (aSrc) => aSrc.progressProvider == aProgressProvider)

        _.forEach(removed, (aSrc) => {

            if(!_.isEmpty(aSrc?.subOnChange))
                aSrc?.subOnChange.unsubscribe()

            if(!_.isEmpty(aSrc?.subOnComplete))
                aSrc?.subOnComplete.unsubscribe()

        })

        self._updateState(false)
    }

    removeAllSources(): void {
        const self = this

        let removed = self.arrSources
        self.arrSources = []

        _.forEach(removed, (aSrc) => {

            if(!_.isEmpty(aSrc?.subOnChange))
                aSrc?.subOnChange.unsubscribe()

            if(!_.isEmpty(aSrc?.subOnComplete))
                aSrc?.subOnComplete.unsubscribe()

        })

        self._updateState(false)
    }


    onSourceComplete(aProgressProvider: IProgressProvider): void {
        if (_.isEmpty(aProgressProvider))
            return
        this._updateState(true)
    }

    onSourceChange(aProgressProvider: IProgressProvider): void {
        if(_.isEmpty(aProgressProvider))
            return
        this._updateState(false)
    }

    _updateState(bComplete: boolean): void {
        //--
        if(_.isEmpty(this.arrSources)){
            //
            this.process_completed = true;
            this.process_running = false;
            this.process_pcnt_complete = 0;
            this.process_progress_numerator = 0;
            this.process_failed = false;
            this.process_exception = {};
            this.progress_message_id = "";
            this.progress_message_text = "";
            this._notify()
            return
        }

        let totalCount = this.arrSources.length

       if(totalCount == 1){
           let pp = this.arrSources[0].progressProvider
           if(pp){
               // Copy state from single child
               this.process_running = pp.process_running
               this.process_pcnt_complete = pp.process_pcnt_complete
               this.process_progress_numerator = pp.process_progress_numerator
               this.process_progress_denominator = pp.process_progress_denominator
               this.process_completed = pp.process_completed
               this.process_failed = pp.process_completed
               this.process_exception = pp.process_exception
               this.progress_message_id = pp.progress_message_id
               this.progress_message_text = pp.progress_message_text
               this._notify()
           }
           return
       }

        //
        let runningCount = 0
        let failedCount = 0
        let arrExceptions: any[] = []

        let completeCount = 0
        _.forEach(this.arrSources, (aSrc) => {
            //--
            let pp = aSrc?.progressProvider
            if(_.isEmpty(pp))
                return

            if(pp.process_completed)
                completeCount += 1

            if(pp.process_running)
                runningCount += 1

            if(pp.process_failed) {
                failedCount += 1
                arrExceptions.push(pp.process_exception)
            }
        })

        //--
        this.process_pcnt_complete = runningCount/ totalCount
        this.process_progress_numerator = runningCount
        this.process_progress_denominator = totalCount
        this.process_running = (runningCount > 0)
        this.process_completed = (runningCount == 0)
        this.process_failed = (failedCount > 0)
        this.process_exception = arrExceptions
        this._notify()

    }

    // Not Implemented
    addListener(aProgressProvider: IProgressProvider): void { }
    addListenerUtilComplete(aProgressProvider: IProgressProvider): void { }
    removeListener(aProgressProvider: IProgressProvider): void { }
    removeAllListeners(): void { }
    async addWSListener(channelId: string, bRemoveOnComplete?: boolean): Promise<void> {   }
    removeWSlistener(pChannelId: string): void { }
    removeAllWSListeners(): void { }
    async listenOn(channelId?: string): Promise<void> {  }
    listenOff(): void {  }
    get listenOnChannelId(): string { return "" }



}